import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { Chip } from '../../atoms/chip/chip';
import { Headline } from '../../atoms/headline/headline';
import { Text } from '../../atoms/text/text';
import utilityStyles from '../../theme/utilities.module.scss';
import styles from './teaser-item.module.scss';
import { TeaserItemLink } from './teaser-item-link';
export const TeaserItem = ({ backgroundColor = 'White', chip, className, headline, link, media, text, textOutside = false, tracking })=>{
    const content = /*#__PURE__*/ _jsxs("div", {
        className: classNames(styles.content, textOutside && styles['content-text-outside']),
        children: [
            chip && /*#__PURE__*/ _jsx(Chip, {
                className: styles.chip,
                children: chip
            }),
            headline && /*#__PURE__*/ _jsx(Headline, {
                className: styles.headline,
                size: "s",
                children: headline
            }),
            text && /*#__PURE__*/ _jsx(Text, {
                className: styles.text,
                children: text
            }),
            !textOutside && link?.title && /*#__PURE__*/ _jsx("div", {
                className: styles['text-cta'],
                children: /*#__PURE__*/ _jsx(Text, {
                    bold: true,
                    className: styles['text-cta-text'],
                    size: "l",
                    children: link?.title
                })
            })
        ]
    });
    return /*#__PURE__*/ _jsxs(TeaserItemLink, {
        backgroundColor: backgroundColor,
        className: className,
        headline: headline,
        link: link,
        tracking: tracking,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: classNames(styles.container, !textOutside && backgroundColor && utilityStyles[`theme-bg-${backgroundColor}`]),
                children: [
                    media && /*#__PURE__*/ _jsx("div", {
                        className: classNames(styles.media),
                        children: media
                    }),
                    !textOutside && content
                ]
            }),
            textOutside && content
        ]
    });
};

//# sourceMappingURL=teaser-item.js.map